import { makeStyles } from '@material-ui/core';
import paleta from '../../configuraciones/paleta';

const styles = makeStyles(() => ({
  root: {
    marginBottom: 16,
    '& > .MuiGrid-item': {
      paddingBlock: 4,
    },
    '& .MuiGrid-item': {
      paddingInline: 8,
    },
  },
  header: {
    width: 10,
  },
  motivo: {
    minHeight: 100,
    width: 400,
    margin: 10,
  },
  textMotivo: {
    margin: 5,
  },
  chip: {
    minWidth: 80,
    maxWidth:  90,
    color: 'white',
    '&.Apartado': { backgroundColor: '#8FA7C1' },
    '&.Vendido': { backgroundColor: '#409A8E' },
    '&.Eliminado': { backgroundColor: paleta.activo.primary },
  },
}));

export default styles;
